import { Card, CardBody, CardHeader } from '@components/card/card';
import i18next from 'i18next';
import React from 'react';
// import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean; error: Error | null }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);

    // إرسال الأخطاء فقط في وضع الإنتاج
    // if (import.meta.env.MODE === 'production') {
    //   Sentry.captureException(error, {
    //     extra: {
    //       componentStack: info.componentStack
    //     }
    //   });
    // }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='container py-2'>
          <div className='row justify-content-center'>
            <div className='col-md-8 col-lg-6'>
              <div className=' text-center p-5'>
                {/* أيقونة الخطأ */}
                <div className='mb-4'>
                  <i className='bi bi-info-circle text-info fs-1'></i>
                </div>

                {/* عنوان الرسالة */}
                <h3 className='h4 text-info mb-3'>
                  {i18next.language === 'en' ? 'Sorry, an unexpected error occurred' : 'عذراً، حدث خطأ غير متوقع'}
                </h3>
                {/* شرح المشكلة */}
                <p className='text-muted mb-4'>
                  {i18next.language === 'en'
                    ? 'An error occurred in this part of the application. Don’t worry, the support team has been notified automatically and will work on fixing it.'
                    : 'حدث خطأ في هذا الجزء من التطبيق. لا تقلق، فريق الدعم الفني قد تم إبلاغه تلقائياً وسيعمل على حل المشكلة.'}
                </p>

                {/* تفاصيل الخطأ   */}
                <div className='mb-4'>
                  <div className=' mt-3'>
                    <Card>
                      <CardHeader>{i18next.language === 'en' ? 'Error Details' : 'تفاصيل الخطأ'}</CardHeader>{' '}
                      <CardBody className=' text-center'>
                        <code className='text-primary fw-bold fs-6'>
                          {this.state.error?.message || 'لا توجد تفاصيل إضافية'}
                        </code>
                      </CardBody>
                      <button
                        className='btn btn-sm btn-outline-secondary'
                        onClick={() => navigator.clipboard.writeText(this.state.error?.message || '')}
                      >
                        <i className='bi bi-clipboard me-1'></i>
                        {i18next.language === 'en' ? 'Copy Details' : 'نسخ التفاصيل'}
                      </button>
                    </Card>
                  </div>
                </div>

                {/* خيارات للمستخدم */}
                <div className='d-grid gap-2 d-sm-flex justify-content-sm-center'>
                  <button className='btn btn-primary' onClick={() => window.location.reload()}>
                    <i className='bi bi-arrow-clockwise me-2'></i>
                    {i18next.language === 'en' ? 'Reload Page' : 'إعادة تحميل الصفحة'}
                  </button>

                  <button
                    className='btn btn-outline-secondary'
                    onClick={() => window.history.back()}
                    disabled={!window.history.state}
                  >
                    <i className='bi bi-arrow-left me-2'></i>
                    {i18next.language === 'en' ? 'Go Back' : 'الرجوع للخلف'}
                  </button>

                  <a href='/' className='btn btn-outline-secondary'>
                    <i className='bi bi-house me-2'></i>
                    {i18next.language === 'en' ? 'Back to Home' : 'العودة للصفحة الرئيسية'}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

//  class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean; error: Error | null; errorInfo: React.ErrorInfo | null }> {
//   constructor(props: any) {
//     super(props);
//     this.state = { hasError: false, error: null, errorInfo: null };
//   }

//   static getDerivedStateFromError(error: Error) {
//     return { hasError: true, error };
//   }

//   componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
//     console.error('ErrorBoundary caught:', error, errorInfo);
//     this.setState({ errorInfo });

//     // إرسال الأخطاء فقط في وضع الإنتاج
//     if (import.meta.env.MODE === 'production') {
//       Sentry.captureException(error, {
//         extra: {
//           componentStack: errorInfo.componentStack
//         }
//       });
//     }
//   }

//   // دالة لنسخ كل تفاصيل الخطأ
//   copyErrorDetails = () => {
//     const errorDetails = this.getFullErrorDetails();
//     navigator.clipboard.writeText(errorDetails);
//   };

//   // دالة لجمع كل تفاصيل الخطأ
//   getFullErrorDetails = (): string => {
//     const { error, errorInfo } = this.state;
//     const details = [
//       '=== ERROR DETAILS ===',
//       `Time: ${new Date().toISOString()}`,
//       `URL: ${window.location.href}`,
//       `User Agent: ${navigator.userAgent}`,
//       '',
//       '=== ERROR MESSAGE ===',
//       error?.message || 'No error message',
//       '',
//       '=== ERROR STACK ===',
//       error?.stack || 'No stack trace',
//       '',
//       '=== COMPONENT STACK ===',
//       errorInfo?.componentStack || 'No component stack'
//     ].join('\n');

//     return details;
//   };

//   render() {
//     if (this.state.hasError) {
//       const { error, errorInfo } = this.state;
//       const isEnglish = i18next.language === 'en';

//       return (
//         <div className='container py-4'>
//           <div className='row justify-content-center'>
//             <div className='col-md-10 col-lg-8'>
//               <div className='text-center p-4'>
//                 {/* أيقونة الخطأ */}
//                 <div className='mb-4'>
//                   <i className='bi bi-exclamation-triangle text-warning fs-1'></i>
//                 </div>

//                 {/* عنوان الرسالة */}
//                 <h3 className='h4 text-warning mb-3'>
//                   {isEnglish ? 'Sorry, an unexpected error occurred' : 'عذراً، حدث خطأ غير متوقع'}
//                 </h3>

//                 {/* شرح المشكلة */}
//                 <p className='text-muted mb-4'>
//                   {isEnglish
//                     ? 'An error occurred in this part of the application. Don\'t worry, the support team has been notified automatically and will work on fixing it.'
//                     : 'حدث خطأ في هذا الجزء من التطبيق. لا تقلق، فريق الدعم الفني قد تم إبلاغه تلقائياً وسيعمل على حل المشكلة.'}
//                 </p>

//                 {/* تفاصيل الخطأ */}
//                 <div className='mb-4'>
//                   <Card className='border-warning'>
//                     <CardHeader className='bg-warning text-white'>
//                       {isEnglish ? 'Error Details' : 'تفاصيل الخطأ'}
//                     </CardHeader>
//                     <CardBody>
//                       {/* الرسالة الأساسية */}
//                       <div className='mb-3'>
//                         <strong>{isEnglish ? 'Error Message:' : 'رسالة الخطأ:'}</strong>
//                         <code className='d-block mt-1 p-2 bg-light rounded text-danger'>
//                           {error?.message || (isEnglish ? 'No details available' : 'لا توجد تفاصيل')}
//                         </code>
//                       </div>

//                       {/* مسار الخطأ (Stack Trace) - قابل للطي */}
//                       {error?.stack && (
//                         <div className='mb-3'>
//                           <details>
//                             <summary className='cursor-pointer'>
//                               <strong>{isEnglish ? 'Stack Trace:' : 'مسار التنفيذ:'}</strong>
//                             </summary>
//                             <pre className='mt-2 p-2 bg-dark text-light rounded small' style={{ maxHeight: '200px', overflow: 'auto' }}>
//                               {error.stack}
//                             </pre>
//                           </details>
//                         </div>
//                       )}

//                       {/* مكونات React - قابل للطي */}
//                       {errorInfo?.componentStack && (
//                         <div className='mb-3'>
//                           <details>
//                             <summary className='cursor-pointer'>
//                               <strong>{isEnglish ? 'Component Stack:' : 'مكونات React:'}</strong>
//                             </summary>
//                             <pre className='mt-2 p-2 bg-light rounded small' style={{ maxHeight: '200px', overflow: 'auto' }}>
//                               {errorInfo.componentStack}
//                             </pre>
//                           </details>
//                         </div>
//                       )}

//                       {/* معلومات إضافية */}
//                       <div className='mt-3'>
//                         <small className='text-muted'>
//                           {isEnglish ? 'Page: ' : 'الصفحة: '}{window.location.href}
//                         </small>
//                         <br />
//                         <small className='text-muted'>
//                           {isEnglish ? 'Time: ' : 'الوقت: '}{new Date().toLocaleString()}
//                         </small>
//                       </div>
//                     </CardBody>
//                   </Card>
//                 </div>

//                 {/* أزرار الإجراءات */}
//                 <div className='d-grid gap-2 d-sm-flex justify-content-sm-center'>
//                   <button className='btn btn-primary' onClick={() => window.location.reload()}>
//                     <i className='bi bi-arrow-clockwise me-2'></i>
//                     {isEnglish ? 'Reload Page' : 'إعادة تحميل الصفحة'}
//                   </button>

//                   <button className='btn btn-outline-info' onClick={this.copyErrorDetails}>
//                     <i className='bi bi-clipboard me-2'></i>
//                     {isEnglish ? 'Copy All Details' : 'نسخ كل التفاصيل'}
//                   </button>

//                   <a href='/' className='btn btn-outline-secondary'>
//                     <i className='bi bi-house me-2'></i>
//                     {isEnglish ? 'Back to Home' : 'العودة للصفحة الرئيسية'}
//                   </a>
//                 </div>

//                 {/* نص مساعد للدعم الفني */}
//                 <div className='mt-4 p-3 bg-light rounded'>
//                   <small className='text-muted'>
//                     {isEnglish
//                       ? 'If the problem persists, please contact support and provide the error details above.'
//                       : 'إذا استمرت المشكلة، يرجى الاتصال بالدعم الفني وتقديم تفاصيل الخطأ أعلاه.'}
//                   </small>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }
//     return this.props.children;
//   }
// }
